import { Component } from 'react';
import PropTypes from 'prop-types';

class AreasOfExcellence extends Component {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  onClick(area) {
    const { chartHandler = () => {} } = this.props;

    chartHandler({
      filters: { response_tag_ids: area.id },
      mixpanelId: 'areasOfExcellence',
    });

    const areaPerMemberTable = document.querySelector('.js-team-excellence-drill');
    if (areaPerMemberTable !== null) {
      areaPerMemberTable.querySelector(`.tab[data-tab-name="${area.caption}"]`).click();
      areaPerMemberTable.querySelector(`[data-column-key="${area.caption}"]`).click();
    }
  }

  render() {
    const lineHeight = '2.6';
    const data = this.props.data;
    const rowStyle = {
      borderBottomWidth: '1px',
      borderBottomColor: 'rgba(0, 0, 0, 0.1',
      borderBottomStyle: 'solid',
      cursor: 'pointer',
      fontSize: '14px',
      color: '#77777c',
      padding: '5px',
    };
    const headerRowStyle = { ...rowStyle };
    delete headerRowStyle.cursor;
    const headerStyle = {
      color: '#333',
      fontSize: '14px',
      fontWeight: '600',
      paddingRight: '5px',
      lineHeight: lineHeight,
    };
    return (
      <div style={{ margin: '20px' }}>
        <table style={{ width: '100%' }}>
          <tbody>
            <tr style={headerRowStyle}>
              {['Area', 'Count', '% of responses'].map(title => {
                return (
                  <th key={title} style={headerStyle}>
                    {title}
                  </th>
                );
              })}
            </tr>
            {data.map(area => {
              return (
                <tr
                  key={area.caption}
                  style={rowStyle}
                  onClick={() => this.onClick(area)}
                  data-target=".js-team-excellence-drill"
                  data-toggle="modal"
                  data-tab-name={area.caption}
                >
                  {['caption', 'total', 'percent'].map(key => {
                    return (
                      <td
                        key={key}
                        style={{ lineHeight }}
                        {...(key === 'caption' ? { 'data-notranslate': true } : {})}
                      >
                        {area[key]}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default AreasOfExcellence;
